export default __webpack_public_path__ + "static/icon-32-6-1418721a05edc74f7f9bd3fbcbda6ce9.png";